import { getCurrentRoute } from "../../utils/current-route";

const API_ROUTES = {
  get DEFAULT_ROUTE() {
    return getCurrentRoute();
  },
  get LOAD_MORE() {
    return `${this.DEFAULT_ROUTE}/more`;
  },
};

export default API_ROUTES;
